/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SubmitRecoveryActivitiesRequest} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'
import {SubmitRecoveryActivitiesResponse} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'


export const submitRecoveryActivities = (request: SubmitRecoveryActivitiesRequest, options?: CashRequestOptions) => post<SubmitRecoveryActivitiesRequest, SubmitRecoveryActivitiesResponse>("/2.0/cash/submit-recovery-activities", request, {...options, rejectOnError: true })